/**
 * Google Sheets workbook — single source of truth for the storefront + Apps Script.
 * Keep scripts/google-apps-script-orders.gs SPREADSHEET_ID in sync with GOOGLE_SPREADSHEET_ID.
 *
 * Workbook:
 * https://docs.google.com/spreadsheets/d/1d8vw22cEBtzSoURxaMF9ezznCP5i54A4GMja1afBmfY/edit?gid=0
 */

export const GOOGLE_SPREADSHEET_URL =
  "https://docs.google.com/spreadsheets/d/1d8vw22cEBtzSoURxaMF9ezznCP5i54A4GMja1afBmfY/edit";

export const GOOGLE_SPREADSHEET_ID = "1d8vw22cEBtzSoURxaMF9ezznCP5i54A4GMja1afBmfY";

/** opensheet.elk.sh needs link sharing: Share → Anyone with the link → Viewer. */
export const GOOGLE_SPREADSHEET_SHARE_HINT =
  "Share this workbook: Anyone with the link → Viewer (required for opensheet product catalog).";

/** Tab names used by Apps Script and opensheet. */
export const SHEET_TABS = {
  products: "Products",
  orders: "Orders",
  couponCodes: "Coupon codes",
  reviews: "Reviews",
  contactMessages: "ContactMessages",
  adminTracking: "AdminTrackingDetails",
};

/** Products catalog tab (gid=0). Public read via opensheet. */
export const PRODUCTS_SHEET_TAB = SHEET_TABS.products;

/** Row 1 headers on the Products tab (must match the live sheet). */
export const PRODUCTS_HEADER_ROW = [
  "Box id",
  "Name",
  "Description",
  "Color",
  "Box Group",
  "Height",
  "Length",
  "Width",
  "Weight", // grams (dimensions above are inches)
  "Cost",
  "Total cost",
  "Selling price",
  "Discount percent",
  "New selling price",
  "Status",
  "Quantity",
  "Photo link(s)",
  "Video link(s)",
  "Customisation image", // optional Drive URL — lid photo for /customise only
  "Customisation photo #", // optional 1-based index into Photo link(s) stills
];

/** Recommended Orders tab headers — run writeOrdersHeaderRowOnce() in Apps Script to apply. */
export const ORDERS_HEADER_ROW = [
  "Timestamp",
  "Order ID",
  "Name",
  "Email",
  "Phone",
  "Address",
  "Pincode",
  "Items",
  "Subtotal",
  "Profit",
  "Shipping",
  "Shipping courier",
  "Courier company id",
  "Shipping ETD",
  "Total",
  "Coupon code",
  "Coupon discount",
  "Payment method",
  "Payment status",
  "SMEPay order id",
  "SMEPay slug",
  "AWB No",
  "Shiprocket order id",
  "Shiprocket shipment id",
  "Shipping label URL",
  "Tracking URL",
  "Tracking status",
];

export const COUPON_CODES_HEADER_ROW = [
  "Coupon code",
  "Discount type",
  "Discount value",
  "Start date",
  "End date",
  "Active",
  "Max uses per email",
];

export const REVIEWS_HEADER_ROW = [
  "Timestamp",
  "Product ID",
  "Rating",
  "Comment",
  "Email",
  "Order ID",
  "Status",
];

/** Public read-only JSON for the Products tab (opensheet). Override via REACT_APP_PRODUCTS_SHEET_URL. */
export const PRODUCTS_SHEET_URL =
  (process.env.REACT_APP_PRODUCTS_SHEET_URL || "").trim() ||
  `https://opensheet.elk.sh/${GOOGLE_SPREADSHEET_ID}/${PRODUCTS_SHEET_TAB}`;

export function opensheetTabUrl(tabName) {
  return `https://opensheet.elk.sh/${GOOGLE_SPREADSHEET_ID}/${encodeURIComponent(tabName)}`;
}
